<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="modal-title fs-5 text-truncate pe-2">{{ 'YOUR_CLICK_SHOULD_HAVE_OPENED_IN_A_NEW_TAB' | translate }}</h1>
  <p class="mb-4">{{ 'IF_THAT_IS_NOT_WHAT_HAPPENED_BELOW_ARE_SOLUTIONS_TO_ALLOW_POP_UPS' | translate }}</p>

  <p class="mb-1">
    Google Chrome: <br />
    <a
      class="fst-italic text-decoration-underline"
      href="https://support.google.com/chrome/answer/95472"
      rel="noopener noreferrer"
      target="_blank"
      >https://support.google.com/chrome/answer/95472</a
    >
  </p>
  <p class="mb-0">
    Safari: <br />
    <a
      class="fst-italic text-decoration-underline"
      href="https://support.apple.com/en-us/guide/safari/"
      rel="noopener noreferrer"
      target="_blank"
      >https://support.apple.com/en-us/guide/safari/</a
    >
  </p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="close()">
    {{ 'CLOSE' | translate }}
  </button>
</app-modal-footer>
